'use client';

import ImageOptimizer from '@/components/image-optimizer';
import { DefaultCallNumber } from '@/data/globals.data';
import { useStoreContactList } from '@/services/query/store.query';
import { StoreType } from '@/services/types/store.type';
import Image from 'next/image';
import Link from 'next/link';

const Footer = () => {
  const { data: branchList } = useStoreContactList(StoreType.DIRECT);
  const branches = branchList?.data ?? [];

  return (
    <footer className="bg-bg-grayblue desktop:px-0 desktop:py-20 px-6 py-10">
      <div className="mx-auto max-w-7xl">
        <div className="desktop:flex-row flex flex-col justify-around">
          {/* Left Column */}
          <div className="flex flex-col">
            <div className="item-start mb-8">
              <Link href="/">
                <ImageOptimizer
                  src="/images/logo.webp"
                  alt="회사 로고"
                  width={183}
                  height={30}
                />
              </Link>
            </div>

            <div className="mb-8">
              <p className="typo-16 text-level-2 mb-5 font-bold">
                <Link href="/privacy">개인정보처리방침</Link>
              </p>
              <p className="text-level-2 mb-3 text-[18px] font-bold">
                (주)드라이빙존 운전면허
              </p>
              <p className="typo-16 text-level-2 mb-3 font-medium">
                대표: 이영은
              </p>
              <p className="typo-16 text-level-2 mb-3 font-medium">
                서울특별시 강남구 테헤란로114길 26 두원빌딩 2층 202호
              </p>
              <div className="desktop:flex-row desktop:gap-2 flex flex-col">
                <p className="typo-16 text-level-2 mb-3 font-medium">
                  사업자등록번호 : 486-88-00482
                </p>
                <p className="typo-16 text-level-2 font-medium">
                  e-mail : help@drivingzone.co.kr
                </p>
              </div>
            </div>
            <div className="desktop:flex hidden gap-3">
              <Link href="https://www.instagram.com/drivingzone_official/">
                <ImageOptimizer
                  src="/images/icons/icon_instagram.png"
                  alt="인스타그램 드라이빙존"
                  width={30}
                  height={30}
                />
              </Link>
              <Link href="https://www.youtube.com/channel/UCJF1icrhWYSNtIC4jciiYVQ">
                <ImageOptimizer
                  src="/images/icons/icon_youtube.png"
                  alt="유튜브 드라이빙존"
                  width={30}
                  height={30}
                />
              </Link>
              <Link href="https://blog.naver.com/drivingzone0509">
                <ImageOptimizer
                  src="/images/icons/icon_blog.png"
                  alt="블로그 드라이빙존"
                  width={30}
                  height={30}
                />
              </Link>
            </div>
            <div className="text-level-6 typo-14 desktop:block mt-5 hidden leading-tight font-medium">
              Copyright 2025. 드라이빙존 운전면허 Inc.
              <br /> all rights reserved.
            </div>
          </div>

          {/* Right Column */}
          <div className="flex flex-col">
            <div className="mb-8">
              <h2 className="text-deepblue typo-16 mb-5 font-bold">대표번호</h2>
              <p className="typo-24 text-level-2 font-extrabold">
                {DefaultCallNumber}
              </p>
              <div className="typo-16 font-medium">
                <p className="text-level-2 mt-3">
                  평일&nbsp;: <span className="font-bold">09:00 - 21:00</span>
                </p>
                <p className="text-level-2 mt-3">
                  주말&nbsp;: <span className="font-bold">10:00 - 17:00</span>{' '}
                  <span className="text-level-6">(공휴일 휴무)</span>
                </p>
              </div>
            </div>
            <div className="mb-7">
              <h2 className="text-deepblue typo-16 mb-5 font-bold">
                직영점별 번호
              </h2>
              <div className="typo-16 grid grid-cols-1 gap-x-3">
                {branches.map((branch) => (
                  <div key={branch.name} className="mb-3 flex">
                    <span className="typo-16 text-level-3 pr-2">
                      {branch.name}
                    </span>
                    <span className="typo-16 text-level-2 font-bold">
                      {branch.phoneNumber}
                    </span>
                  </div>
                ))}
              </div>
            </div>
            <Link href="/franchise">
              <div className="text-level-2 typo-17 inline-flex items-center justify-center rounded-full border border-[rgba(17,17,17,0.05)] bg-white px-[35px] py-3 text-center font-bold hover:bg-gray-100">
                가맹문의&nbsp;&nbsp;
                <Image
                  src="/images/icons/icon_arrow_right_blue1.svg"
                  alt=""
                  width={16}
                  height={16}
                />
              </div>
            </Link>
          </div>
        </div>
        <div className="desktop:hidden my-5 flex space-x-2">
          <Link href="https://www.instagram.com/drivingzone_official/">
            <ImageOptimizer
              src="/images/icons/icon_instagram.png"
              alt="인스타그램 드라이빙존"
              width={36}
              height={36}
            />
          </Link>
          <Link href="https://www.youtube.com/channel/UCJF1icrhWYSNtIC4jciiYVQ">
            <ImageOptimizer
              src="/images/icons/icon_youtube.png"
              alt="유튜브 드라이빙존"
              width={36}
              height={36}
            />
          </Link>
          <Link href="https://blog.naver.com/drivingzone0509">
            <ImageOptimizer
              src="/images/icons/icon_blog.png"
              alt="블로그 드라이빙존"
              width={36}
              height={36}
            />
          </Link>
        </div>

        <div className="text-level-6 typo-14 desktop:hidden mt-5 leading-snug font-medium">
          Copyright 2025. 드라이빙존 운전면허 Inc.
          <br /> all rights reserved.
        </div>
      </div>
      {/* </FullWidthSection> */}
    </footer>
  );
};

export default Footer;
